import { NativeElement2p8z5z0r9meck as NativeElement } from './NativeElement.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { NativeContainerElement390em0tm6yzca as NativeContainerElement } from './NativeContainerElement.commonHtml.mjs';
import {
  ContainerElementjaaooy2agvhc as ContainerElement,
  Debugger_getInstancengm4b9abzu1y as Debugger_getInstance,
  get_spacingForChildCornerRadiitm4iw4dfs7u2 as get_spacingForChildCornerRadii,
} from './Element.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  get_indices3txodfl5wuu5j as get_indices,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NativeContainerElementCommonCodeClass;
function NativeContainerElementCommonCode() {
  if (NativeContainerElementCommonCodeClass === VOID) {
    class $ extends NativeElement() {
      constructor(context) {
        super(context);
        this.internalChildren_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.parentElement_1 = this;
        this.outermostElement_2 = this;
      }
      get_underlyingNativeElement_vngz33_k$() {
        return this instanceof NativeContainerElement() ? this : THROW_CCE();
      }
      get_children_4cwbp4_k$() {
        return this.internalChildren_1;
      }
      nativeWillAddChild_kc1wyr_k$(element) {
      }
      set_outermostElement_j4i68j_k$(value) {
        var tmp = this;
        var tmp0_elvis_lhs = isInterface(value, ContainerElement()) ? value : null;
        tmp.parentElement_1 = tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
        this.outermostElement_2 = value;
      }
      get_outermostElement_wqahza_k$() {
        return this.outermostElement_2;
      }
      willAddChild_hz2iwc_k$(element) {
        if (this.checkIsShutdown_q5o5gy_k$('willAddChild'))
          return Unit_instance;
        element.get_underlyingNativeElement_vngz33_k$().set_parent_pjy9os_k$(this.parentElement_1);
        this.nativeWillAddChild_kc1wyr_k$(element);
      }
      addChild_51cm2s_k$(index, element) {
        if (this.checkIsShutdown_q5o5gy_k$('addChild'))
          return Unit_instance;
        this.internalChildren_1.add_dl6gt3_k$(index, element);
        this.nativeAddChild_hge4nv_k$(index, element);
        var tmp0_safe_receiver = element.get_parent_hy4reb_k$();
        if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_underlyingNativeElement_vngz33_k$()) === this)) {
          element.get_underlyingNativeElement_vngz33_k$().set_parent_pjy9os_k$(this.parentElement_1);
        }
      }
      addChild_2qpft2_k$(element) {
        return this.addChild_51cm2s_k$(this.get_children_4cwbp4_k$().get_size_woubt6_k$(), element);
      }
      removeChild_mjbjbk_k$(index) {
        if (this.checkIsShutdown_q5o5gy_k$('removeChild'))
          return Unit_instance;
        if (!(0 <= index ? index <= (this.get_children_4cwbp4_k$().get_size_woubt6_k$() - 1 | 0) : false))
          throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('' + index + ' not in range ' + get_indices(this.get_children_4cwbp4_k$()).toString());
        this.nativeRemoveChild_8vu7sp_k$(index);
        this.internalChildren_1.removeAt_6niowx_k$(index).onShutdown_5jzxq3_k$();
      }
      removeChild_kofmvd_k$(element) {
        if (this.checkIsShutdown_q5o5gy_k$('removeChild'))
          return Unit_instance;
        var i = this.get_children_4cwbp4_k$().indexOf_si1fv9_k$(element);
        if (!(i === -1)) {
          this.nativeRemoveChild_8vu7sp_k$(i);
          this.internalChildren_1.removeAt_6niowx_k$(i).onShutdown_5jzxq3_k$();
        } else
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(element.toString() + ' is not a child of ' + this.toString() + '!');
      }
      clearChildren_eufjq4_k$() {
        if (this.checkIsShutdown_q5o5gy_k$('clearChildren'))
          return Unit_instance;
        this.nativeClearChildren_cy0j45_k$();
        var _iterator__ex2g4s = this.internalChildren_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var e = _iterator__ex2g4s.next_20eer_k$();
          e.onShutdown_5jzxq3_k$();
        }
        this.internalChildren_1.clear_j9egeb_k$();
      }
      onShutdown_5jzxq3_k$() {
        if (this.isShutdown_1)
          return Unit_instance;
        if (Debugger_getInstance().removeBeforeShutdown_1) {
          var inductionVariable = get_lastIndex(this.internalChildren_1);
          if (0 <= inductionVariable)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + -1 | 0;
              this.removeChild_mjbjbk_k$(index);
            }
             while (0 <= inductionVariable);
        } else {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = this.internalChildren_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            element.onShutdown_5jzxq3_k$();
          }
          this.internalChildren_1.clear_j9egeb_k$();
        }
        super.onShutdown_5jzxq3_k$();
      }
      themeAndBackChanged_kx7s5p_k$(previous, current) {
        // Inline function 'kotlin.let' call
        var it = previous.theme_1;
        var tmp0_elvis_lhs = it.revert_1;
        var oldCascading = tmp0_elvis_lhs == null ? it : tmp0_elvis_lhs;
        // Inline function 'kotlin.let' call
        var it_0 = current.theme_1;
        var tmp0_elvis_lhs_0 = it_0.revert_1;
        var newCascading = tmp0_elvis_lhs_0 == null ? it_0 : tmp0_elvis_lhs_0;
        if (!oldCascading.equals(newCascading)) {
          var _iterator__ex2g4s = this.get_children_4cwbp4_k$().iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var child = _iterator__ex2g4s.next_20eer_k$();
            child.get_underlyingNativeElement_vngz33_k$().refreshTheming_1agefv_k$();
          }
        }
      }
    }
    protoOf($).get_spacingForChildCornerRadii_uorqcm_k$ = get_spacingForChildCornerRadii;
    initMetadataForClass($, 'NativeContainerElementCommonCode', VOID, VOID, [ContainerElement()]);
    NativeContainerElementCommonCodeClass = $;
  }
  return NativeContainerElementCommonCodeClass;
}
//region block: exports
export {
  NativeContainerElementCommonCode as NativeContainerElementCommonCode1o0vbwacxxrc9,
};
//endregion

//# sourceMappingURL=NativeContainerElement.mjs.map
